import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import RadioLabel from 'common/components/elements/inputs/radio-label';
import CheckboxLable from 'common/components/elements/inputs/checkbox-label';

const OptionSection = ({
   options,
   value,
   onChange,
   name,
   isCheckboxType = false,
}) => {
   return (
      <div className='flex flex-col py-1 bg-panel'>
         {
            options.map((option, index) => {
               if(isCheckboxType){
                  const checked = value && value.includes(option.value);
                  return (
                     <CheckboxLable
                        name={ option.value }
                        key={ index.toString() }
                        label={ option.title }
                        checked={ checked }
                        position='right'
                        onChange={ () => {
                           let newValue = [...value]
                           if(checked){
                              newValue = [...newValue].filter(item => item !== option.value)
                           } else {
                              newValue = [
                                 ...newValue,
                                 option.value,
                              ]
                           }
                           onChange(name, newValue)
                        } }
                        padding=' py-2 px-4'
                     />
                  )
               }
               return (
                  <OptionRadioElement
                     key={ index.toString() }
                     option={ option }
                     checked={ value === option.value }
                     onChange={ () => {
                        onChange(name, option.value)
                     } }
                  />
               )
            })
         }
      </div>
   )
}


const OptionRadioElement = ({
   option,
   onChange,
   checked,
}) => {
   return (
      <RadioLabel
         id={ option.value }
         labelColor='text-major !leading-[20px]'
         checked={ checked }
         onChange={ onChange }
         paddingY=' py-[10px]'
         className={ cx({
            '!px-4 flex-row-reverse gap-3': true,
            'bg-hover': checked,
         }) }
         radioParentClassName=''
      >
         <div className='flex flex-1'>
            <span className='text-major leading-[20px] text-base'>{option.title }</span>
         </div>
      </RadioLabel>
   )
}

OptionRadioElement.propTypes = {
   option: PropTypes.object,
   value: PropTypes.any,
   onChange: PropTypes.func,
   checked: PropTypes.bool,
};
OptionSection.propTypes = {
   options: PropTypes.array,
   value: PropTypes.any,
   onChange: PropTypes.func,
   name: PropTypes.string,
   isCheckboxType: PropTypes.bool,
};

export default OptionSection;

export {
   OptionRadioElement,
}
